import * as React from 'react'

import { CSSProperties } from 'styled-components'
import { motion, HTMLMotionProps } from 'framer-motion'

import { isProxyAvailable } from '../utils'

export const MotionDiv = React.forwardRef(
  (
    props: HTMLMotionProps<'div'> & { ieOnlyStyles?: CSSProperties },
    ref: any,
  ) => {
    return (
      <React.Fragment>
        {isProxyAvailable ? (
          <motion.div ref={ref} {...props} />
        ) : (
          // MotionStyles and CSSProperties (div styles) interfaces are
          // different, but this assignment can never break
          <div
            ref={ref}
            style={props.ieOnlyStyles ?? (props.style as CSSProperties)}
            className={props.className}
          >
            {props.children}
          </div>
        )}
      </React.Fragment>
    )
  },
)
